module.exports = __webpack_public_path__ + "UX4.png?b4e265005e76acd151cb100d12a8deff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX4.png
// module id = 90
// module chunks = 0